// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ButtonTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS */
/* stylelint-disable property-disallowed-list -- DS */

.Button-module__Base__HXID3 {
    position: relative;
    gap: var(--ds-s);
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    max-width: 100%;
    border: none;
    border-radius: var(--ds-border-radius-xl);
    transition: background-color var(--ds-transition-s);
    user-select: none;
}

.Button-module__BaseDisabled__NXWR7 {
    cursor: default;
}

.Button-module__BaseEnabled__p3W3j {
    cursor: pointer;
}
/* Transparent rather than hidden so the text keeps naming the button while loading */
.Button-module__Invisible__qm8lt {
    opacity: 0;
}

.Button-module__Loading__wRaMu {
    pointer-events: none;
}

.Button-module__LoadingIcon__hvVId {
    position: absolute;
}

.Button-module__BaseFlex__RriHr {
    display: flex;
    flex: 1;
    width: 100%;
}

.Button-module__BaseInline__iZDeH {
    display: inline-flex;
}
/* Sizes */
/* ------------ */
.Button-module__Big__r4WvV {
    padding: var(--ds-sm) var(--ds-l);
}

.Button-module__Medium__Vh2VD {
    padding: var(--ds-s) var(--ds-m);
}

.Button-module__Small__BNrvE {
    padding: var(--ds-xs) var(--ds-sm);
}
/* Line Height */
.Button-module__LineHeightBig__pt9xA {
    line-height: var(--ds-line-height-big);
}

.Button-module__LineHeightMedium__Alw9e {
    line-height: var(--ds-line-height-medium);
}

.Button-module__LineHeightSmall__C8kXl {
    line-height: var(--ds-line-height-small);
}
/* Primary */
/* ------------ */
.Button-module__KindPrimaryEnabled__buwzG {
    color: var(--ds-primary-button-color);
    background-color: var(--ds-primary-button-bg-color);
}

.Button-module__KindPrimaryEnabled__buwzG:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Button-module__KindPrimaryEnabled__buwzG:hover {
    background-color: var(--ds-primary-button-hover-bg-color);
}

.Button-module__KindPrimaryDisabled__A7ZdJ {
    color: var(--ds-primary-button-disabled-color);
    background-color: var(--ds-primary-button-disabled-bg-color);
}

.Button-module__KindPrimaryLoading__kYPqT {
    background-color: var(--ds-primary-button-loading-bg-color);
}
/* Secondary */
/* ------------ */
.Button-module__KindSecondaryEnabled__dxeb6 {
    color: var(--ds-secondary-button-color);
    background-color: var(--ds-secondary-button-bg-color);
    box-shadow: var(--ds-secondary-button-box-shadow);
}

.Button-module__KindSecondaryEnabled__dxeb6:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Button-module__KindSecondaryEnabled__dxeb6:hover {
    background-color: var(--ds-secondary-button-hover-bg-color);
}

.Button-module__KindSecondaryDisabled__vjsGN {
    color: var(--ds-secondary-button-disabled-color);
    background-color: var(--ds-secondary-button-disabled-bg-color);
    box-shadow: none;
}

.Button-module__KindSecondaryLoading__NlZd9 {
    background-color: var(--ds-secondary-button-loading-bg-color);
}
/* Danger */
/* ------------ */
.Button-module__KindDangerEnabled__vJ0w6 {
    color: var(--ds-danger-button-color);
    background-color: var(--ds-danger-button-bg-color);
}

.Button-module__KindDangerEnabled__vJ0w6:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Button-module__KindDangerEnabled__vJ0w6:hover {
    color: var(--ds-danger-button-hover-color);
    background-color: var(--ds-danger-button-hover-bg-color);
    box-shadow: var(--ds-danger-button-hover-box-shadow);
}

.Button-module__KindDangerDisabled__Zyp7E {
    color: var(--ds-danger-button-disabled-color);
    background-color: var(--ds-danger-button-disabled-bg-color);
    pointer-events: none;
}

.Button-module__KindDangerLoading__g0pk7 {
    background-color: var(--ds-danger-button-loading-bg-color);
}
/* Ghost */
/* ------------ */
.Button-module__KindGhostEnabled__JajCW {
    color: var(--ds-ghost-button-color);
    background-color: var(--ds-ghost-button-bg-color);
}

.Button-module__KindGhostEnabled__JajCW:hover {
    color: var(--ds-ghost-button-hover-color);
    background-color: var(--ds-ghost-button-bg-color);
}

.Button-module__KindGhostEnabled__JajCW:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Button-module__KindGhostDisabled__r2eoW {
    color: var(--ds-ghost-button-disabled-color);
    background-color: var(--ds-ghost-button-bg-color);
    pointer-events: none;
}

.Button-module__KindGhostLoading__j5795 {
    background-color: var(--ds-ghost-button-bg-color);
}
/* Ghost Danger */
/* ------------ */
.Button-module__KindGhostDangerEnabled__tH0VJ {
    color: var(--ds-ghost-danger-button-color);
    background-color: var(--ds-ghost-danger-button-bg-color);
}

.Button-module__KindGhostDangerEnabled__tH0VJ:hover {
    color: var(--ds-ghost-danger-button-hover-color);
    background-color: var(--ds-ghost-danger-button-bg-color);
}

.Button-module__KindGhostDangerEnabled__tH0VJ:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Button-module__KindGhostDangerDisabled__XXoAy {
    color: var(--ds-ghost-danger-button-disabled-color);
}

.Button-module__KindGhostDangerLoading__LgPpT {
    background-color: var(--ds-ghost-danger-button-bg-color);
}
/* Link */
/* ------------ */
.Button-module__KindLinkEnabled__GFblc {
    color: var(--ds-link-button-color);
    background-color: var(--ds-link-button-bg-color);
    border-radius: var(--ds-border-radius-xs);
}

.Button-module__KindLinkEnabled__GFblc:hover {
    color: var(--ds-link-button-hover-color);
    background-color: var(--ds-link-button-bg-color);
}

.Button-module__KindLinkEnabled__GFblc:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
}

.Button-module__KindLinkDisabled__fYMxn {
    color: var(--ds-link-button-disabled-color);
    background-color: var(--ds-link-button-bg-color);
    border-radius: var(--ds-border-radius-xs);
    pointer-events: none;
}

.Button-module__KindLinkLoading__KmBqV {
    background-color: var(--ds-link-button-bg-color);
    border-radius: var(--ds-border-radius-xs);
}
/* Used for Ghost Danger/Ghost/Link */
.Button-module__NoPadding__nS0ej {
    padding: 0;
}

.Button-module__IsHidden__aGKz0 {
    position: fixed;
    top: var(--ds-sm);
    left: 50%;
    z-index: var(--ds-z-index-10);
    transform: translate(-50%, -200%);
    opacity: 0;
    transition:
        transform var(--ds-transition-s),
        opacity var(--ds-transition-s);
}

.Button-module__IsHidden__aGKz0:focus {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
    transform: translate(-50%, 0);
    opacity: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Base": `Button-module__Base__HXID3`,
	"BaseDisabled": `Button-module__BaseDisabled__NXWR7`,
	"BaseEnabled": `Button-module__BaseEnabled__p3W3j`,
	"Invisible": `Button-module__Invisible__qm8lt`,
	"Loading": `Button-module__Loading__wRaMu`,
	"LoadingIcon": `Button-module__LoadingIcon__hvVId`,
	"BaseFlex": `Button-module__BaseFlex__RriHr`,
	"BaseInline": `Button-module__BaseInline__iZDeH`,
	"Big": `Button-module__Big__r4WvV`,
	"Medium": `Button-module__Medium__Vh2VD`,
	"Small": `Button-module__Small__BNrvE`,
	"LineHeightBig": `Button-module__LineHeightBig__pt9xA`,
	"LineHeightMedium": `Button-module__LineHeightMedium__Alw9e`,
	"LineHeightSmall": `Button-module__LineHeightSmall__C8kXl`,
	"KindPrimaryEnabled": `Button-module__KindPrimaryEnabled__buwzG`,
	"KindPrimaryDisabled": `Button-module__KindPrimaryDisabled__A7ZdJ`,
	"KindPrimaryLoading": `Button-module__KindPrimaryLoading__kYPqT`,
	"KindSecondaryEnabled": `Button-module__KindSecondaryEnabled__dxeb6`,
	"KindSecondaryDisabled": `Button-module__KindSecondaryDisabled__vjsGN`,
	"KindSecondaryLoading": `Button-module__KindSecondaryLoading__NlZd9`,
	"KindDangerEnabled": `Button-module__KindDangerEnabled__vJ0w6`,
	"KindDangerDisabled": `Button-module__KindDangerDisabled__Zyp7E`,
	"KindDangerLoading": `Button-module__KindDangerLoading__g0pk7`,
	"KindGhostEnabled": `Button-module__KindGhostEnabled__JajCW`,
	"KindGhostDisabled": `Button-module__KindGhostDisabled__r2eoW`,
	"KindGhostLoading": `Button-module__KindGhostLoading__j5795`,
	"KindGhostDangerEnabled": `Button-module__KindGhostDangerEnabled__tH0VJ`,
	"KindGhostDangerDisabled": `Button-module__KindGhostDangerDisabled__XXoAy`,
	"KindGhostDangerLoading": `Button-module__KindGhostDangerLoading__LgPpT`,
	"KindLinkEnabled": `Button-module__KindLinkEnabled__GFblc`,
	"KindLinkDisabled": `Button-module__KindLinkDisabled__fYMxn`,
	"KindLinkLoading": `Button-module__KindLinkLoading__KmBqV`,
	"NoPadding": `Button-module__NoPadding__nS0ej`,
	"IsHidden": `Button-module__IsHidden__aGKz0`
};
export default ___CSS_LOADER_EXPORT___;
